// Real venue photos
const BALLROOM = "https://customer-assets.emergentagent.com/job_luxury-events-sibiu/artifacts/6ej9lec9_5C615569-3220-4EAD-A3A2-26E7CB1F8B5F.png";
const TABLE = "https://customer-assets.emergentagent.com/job_luxury-events-sibiu/artifacts/z39h29j3_IMG_8876.jpeg";
const FLORAL = "https://customer-assets.emergentagent.com/job_luxury-events-sibiu/artifacts/wog3bf6m_6BBAA16D-AD7B-409A-8AEA-5AF8CFAA0883.png";
// Premium stock
const BOTEZ = "https://images.unsplash.com/photo-1780586377914-b3ede597d82d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const CORPORATE = "https://images.unsplash.com/photo-1700514077430-3659e38eb5e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const ANIVERSARI = "https://images.unsplash.com/photo-1741969494307-55394e3e4071?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const PETRECERI = "https://images.unsplash.com/photo-1580657274234-7339717f4541?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const services = [
  {
    slug: "nunti",
    name: "Nunți",
    seoTitle: "Sală Nunți Sibiu | Locație Nuntă de Lux - Elysium Events",
    seoDescription: "Sală de nunți premium în Sibiu, capacitate până la 300 de invitați. Decor elegant, schelă de lumini, efecte speciale și meniu rafinat. Solicită ofertă!",
    keywords: "sală nunți Sibiu, locație nuntă Sibiu, restaurant nunți Sibiu, sală evenimente Sibiu",
    tagline: "Ziua în care spui DA merită o locație de poveste",
    hero: BALLROOM,
    intro: "Visezi la o nuntă elegantă, cu o atmosferă de basm și fiecare detaliu pus la punct? La Elysium Events transformăm cea mai importantă zi din viața ta într-o experiență de neuitat pentru tine și cei până la 300 de invitați ai voștri.",
    benefits: [
      "Sală spectaculoasă cu decor rafinat și tavan draping",
      "Schelă profesională de lumini pentru o atmosferă magică",
      "Fum greu pentru un dans al mirilor de poveste",
      "Meniu premium personalizabil și open bar",
      "Coordonator dedicat pe tot parcursul evenimentului"
    ],
    galleryImages: [BALLROOM, FLORAL, TABLE]
  },
  {
    slug: "botezuri",
    name: "Botezuri",
    seoTitle: "Sală Botez Sibiu | Petrecere Botez Elegantă - Elysium Events",
    seoDescription: "Organizează botezul copilului tău într-o sală elegantă din Sibiu. Decor delicat, meniu premium și atmosferă caldă pentru cei mici și invitați. Cere ofertă!",
    keywords: "sală botez Sibiu, botez Sibiu, petrecere botez Sibiu, locație botez Sibiu",
    tagline: "Prima mare sărbătoare a celui mic, într-un cadru de vis",
    hero: BOTEZ,
    intro: "Botezul este un moment plin de emoție și bucurie. Îți oferim un cadru elegant și cald, cu servicii impecabile, ca tu să te bucuri de această zi specială alături de familie și prieteni.",
    benefits: [
      "Decor delicat, adaptat temei botezului",
      "Spațiu generos și sigur pentru cei mici",
      "Meniu premium și candy bar cu deserturi fine",
      "Oglindă magică pentru poze instant cu invitații",
      "Personal atent la fiecare detaliu"
    ],
    galleryImages: [BOTEZ, TABLE, FLORAL]
  },
  {
    slug: "cununii",
    name: "Cununii",
    seoTitle: "Locație Cununie Civilă Sibiu | Elysium Events",
    seoDescription: "Sărbătorește cununia civilă într-o locație elegantă din Sibiu. Cadru intim și rafinat, perfect pentru cel mai romantic moment. Solicită o ofertă personalizată!",
    keywords: "cununie civilă Sibiu, locație cununie Sibiu, sală cununie Sibiu",
    tagline: "Un cadru intim și elegant pentru promisiunea voastră",
    hero: FLORAL,
    intro: "Fie că vrei o cununie civilă intimă sau o petrecere elegantă alături de cei dragi, Elysium Events îți oferă decorul perfect pentru unul dintre cele mai frumoase momente din viața voastră.",
    benefits: [
      "Cadru romantic cu perete floral și lumini ambientale",
      "Aranjamente elegante și personalizabile",
      "Atmosferă intimă sau petrecere generoasă",
      "Servicii de catering premium",
      "Locație ideală pentru ședințe foto memorabile"
    ],
    galleryImages: [FLORAL, BALLROOM, TABLE]
  },
  {
    slug: "evenimente-corporate",
    name: "Evenimente Corporate",
    seoTitle: "Evenimente Corporate Sibiu | Sală Conferințe & Gală - Elysium Events",
    seoDescription: "Locație premium pentru evenimente corporate în Sibiu: conferințe, gale, team building și lansări. Sonorizare, iluminat profesional și servicii impecabile.",
    keywords: "evenimente corporate Sibiu, sală conferințe Sibiu, gală corporate Sibiu, team building Sibiu",
    tagline: "Impresionează-ți partenerii și echipa la standarde de 5 stele",
    hero: CORPORATE,
    intro: "De la conferințe și lansări de produs, la gale și petreceri de companie, Elysium Events îți pune la dispoziție o locație versatilă și profesională, dotată complet pentru evenimente corporate de succes.",
    benefits: [
      "Capacitate până la 300 de persoane, configurabilă",
      "Sistem profesional de sonorizare și proiecție",
      "Schelă de lumini pentru prezentări și gale",
      "Meniu business și coffee break-uri premium",
      "Parcare proprie și acces facil"
    ],
    galleryImages: [CORPORATE, BALLROOM, FLORAL]
  },
  {
    slug: "aniversari",
    name: "Aniversări",
    seoTitle: "Sală Aniversări Sibiu | Petreceri Aniversare de Lux - Elysium Events",
    seoDescription: "Sărbătorește-ți aniversarea într-o sală elegantă din Sibiu. Decor premium, efecte speciale, muzică și meniu rafinat pentru o petrecere de neuitat.",
    keywords: "sală aniversări Sibiu, petrecere aniversare Sibiu, locație aniversare Sibiu",
    tagline: "Fiecare aniversare merită sărbătorită în stil mare",
    hero: ANIVERSARI,
    intro: "Fie că este vorba de o aniversare de vârstă rotundă sau de o petrecere tematică, îți oferim spațiul, decorul și atmosfera perfectă pentru a sărbători alături de cei dragi.",
    benefits: [
      "Decor personalizat în funcție de tema petrecerii",
      "Efecte speciale: baloane de spumă și lumini spectaculoase",
      "Ring de dans generos și sonorizare de calitate",
      "Meniu și candy bar adaptat preferințelor tale",
      "Oglindă magică pentru amintiri distractive"
    ],
    galleryImages: [ANIVERSARI, TABLE, BALLROOM]
  },
  {
    slug: "petreceri-private",
    name: "Petreceri Private",
    seoTitle: "Petreceri Private Sibiu | Locație Exclusivistă - Elysium Events",
    seoDescription: "Organizează o petrecere privată exclusivistă în Sibiu. Locație elegantă, bar propriu, atmosferă premium și discreție totală pentru evenimentul tău special.",
    keywords: "petreceri private Sibiu, locație petrecere Sibiu, sală privată Sibiu",
    tagline: "Exclusivitate, eleganță și o atmosferă de neuitat",
    hero: PETRECERI,
    intro: "Pentru momentele care merită celebrate în intimitate și stil, Elysium Events îți oferă o locație exclusivistă, cu servicii premium și o atmosferă care îți va impresiona invitații.",
    benefits: [
      "Locație privată și discretă, doar pentru tine",
      "Bar propriu cu cocktailuri și băuturi fine",
      "Atmosferă premium cu iluminat ambiental",
      "Meniu gourmet personalizat",
      "Personal dedicat și servicii impecabile"
    ],
    galleryImages: [PETRECERI, BALLROOM, FLORAL]
  }
];

export const getService = (slug) => services.find((s) => s.slug === slug);
